"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const UserActionPopup_1 = require("@Components/Popups/UserActionPopup");
const user_maintenance_actions_1 = require("@Components/UserRowComponent/user-maintenance-actions");
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
const rightsholderUser_1 = require("@App/api/routes/rightsholder/rightsholderUser");
const UserRowPopup = (props) => {
    const { preloaderStore, rightsholderUserStore, popupStore, userStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { onCloseConfirmPopup, actionType, userData, onReloadData } = props;
    const onResentInvite = () => __awaiter(void 0, void 0, void 0, function* () {
        const { firstName, lastName, email, groups } = userData;
        try {
            const formData = { firstName, lastName, email, groups };
            preloaderStore.openTransparentPreloader(true);
            yield rightsholderUserStore.inviteRightsholderUser(formData);
            popupStore.setAlertData(`Invite was resent`, false);
        }
        catch (error) {
            popupStore.setAlertFromError(error);
        }
        onCloseConfirmPopup();
        preloaderStore.openTransparentPreloader(false);
    });
    const onRemoveUser = () => __awaiter(void 0, void 0, void 0, function* () {
        const currentRightsholderId = rightsholderStore.currentRightsholderId;
        const { id, firstName, lastName } = userData;
        if (id) {
            try {
                preloaderStore.openTransparentPreloader(true);
                yield (0, rightsholderUser_1.deleteRightsholderUser)(currentRightsholderId, id);
                onReloadData && (yield onReloadData());
                popupStore.setAlertData(`User ${firstName + ' ' + lastName} was removed`, false);
            }
            catch (error) {
                popupStore.setAlertFromError(error);
            }
            onCloseConfirmPopup();
            preloaderStore.openTransparentPreloader(false);
        }
    });
    const isInternal = userStore.isInternal;
    return (react_1.default.createElement(Popup_1.default, { onClose: onCloseConfirmPopup },
        react_1.default.createElement("div", { className: 'user-action-popup-content' },
            actionType === user_maintenance_actions_1.UserMaintenanceActions.resentInvite && (react_1.default.createElement(UserActionPopup_1.UserActionPopup, { title: 'Resend Invite?', user: userData, onCancel: onCloseConfirmPopup, onConfirm: onResentInvite })),
            actionType === user_maintenance_actions_1.UserMaintenanceActions.removeUser && (react_1.default.createElement(UserActionPopup_1.UserActionPopup, { title: 'Remove User?', user: userData, onCancel: onCloseConfirmPopup, onConfirm: onRemoveUser, disabled: isInternal })))));
};
exports.default = (0, mobx_react_1.observer)(UserRowPopup);
